import {
  CardAccreditoEnum,
  CardAccreditoLabel,
} from '@/core/domain/coupon/coupons/coupons.types';
import { Select, SelectProps } from 'antd';
import { forwardRef } from 'react';

const cardAccreditorOptions = [
  {
    value: CardAccreditoEnum.AMEX_003,
    label: CardAccreditoLabel[CardAccreditoEnum.AMEX_003],
  },
  {
    value: CardAccreditoEnum.BANCO_GE_004,
    label: CardAccreditoLabel[CardAccreditoEnum.BANCO_GE_004],
  },
  {
    value: CardAccreditoEnum.BANCO_SAFRA_005,
    label: CardAccreditoLabel[CardAccreditoEnum.BANCO_SAFRA_005],
  },
  {
    value: CardAccreditoEnum.BANCO_TOPAZIO_006,
    label: CardAccreditoLabel[CardAccreditoEnum.BANCO_TOPAZIO_006],
  },
  {
    value: CardAccreditoEnum.BANCO_TRIANGULO_007,
    label: CardAccreditoLabel[CardAccreditoEnum.BANCO_TRIANGULO_007],
  },
  {
    value: CardAccreditoEnum.BIGCARD_008,
    label: CardAccreditoLabel[CardAccreditoEnum.BIGCARD_008],
  },
  {
    value: CardAccreditoEnum.BOURBON_009,
    label: CardAccreditoLabel[CardAccreditoEnum.BOURBON_009],
  },
  {
    value: CardAccreditoEnum.CABAL_010,
    label: CardAccreditoLabel[CardAccreditoEnum.CABAL_010],
  },
  {
    value: CardAccreditoEnum.CETELEM_011,
    label: CardAccreditoLabel[CardAccreditoEnum.CETELEM_011],
  },
  {
    value: CardAccreditoEnum.CIELO_012,
    label: CardAccreditoLabel[CardAccreditoEnum.CIELO_012],
  },
  {
    value: CardAccreditoEnum.CREDI_21_013,
    label: CardAccreditoLabel[CardAccreditoEnum.CREDI_21_013],
  },
  {
    value: CardAccreditoEnum.ECX_CARD_014,
    label: CardAccreditoLabel[CardAccreditoEnum.ECX_CARD_014],
  },
  {
    value: CardAccreditoEnum.EMBRATEC_015,
    label: CardAccreditoLabel[CardAccreditoEnum.EMBRATEC_015],
  },
  {
    value: CardAccreditoEnum.EMPORIO_CARD_016,
    label: CardAccreditoLabel[CardAccreditoEnum.EMPORIO_CARD_016],
  },
  {
    value: CardAccreditoEnum.FREEDDOM_017,
    label: CardAccreditoLabel[CardAccreditoEnum.FREEDDOM_017],
  },
  {
    value: CardAccreditoEnum.FUNCIONAL_CARD_018,
    label: CardAccreditoLabel[CardAccreditoEnum.FUNCIONAL_CARD_018],
  },
  {
    value: CardAccreditoEnum.HIPERCARD_019,
    label: CardAccreditoLabel[CardAccreditoEnum.HIPERCARD_019],
  },
  {
    value: CardAccreditoEnum.MAPA_020,
    label: CardAccreditoLabel[CardAccreditoEnum.MAPA_020],
  },
  {
    value: CardAccreditoEnum.NOVO_PAG_021,
    label: CardAccreditoLabel[CardAccreditoEnum.NOVO_PAG_021],
  },
  {
    value: CardAccreditoEnum.PERNAMBUCANAS_022,
    label: CardAccreditoLabel[CardAccreditoEnum.PERNAMBUCANAS_022],
  },
  {
    value: CardAccreditoEnum.POLICARD_023,
    label: CardAccreditoLabel[CardAccreditoEnum.POLICARD_023],
  },
  {
    value: CardAccreditoEnum.PROVAR_024,
    label: CardAccreditoLabel[CardAccreditoEnum.PROVAR_024],
  },
  {
    value: CardAccreditoEnum.REDECARD_025,
    label: CardAccreditoLabel[CardAccreditoEnum.REDECARD_025],
  },
  {
    value: CardAccreditoEnum.RENNER_026,
    label: CardAccreditoLabel[CardAccreditoEnum.RENNER_026],
  },
  {
    value: CardAccreditoEnum.RP_CONVENIOS_027,
    label: CardAccreditoLabel[CardAccreditoEnum.RP_CONVENIOS_027],
  },
  {
    value: CardAccreditoEnum.SANTINVEST_028,
    label: CardAccreditoLabel[CardAccreditoEnum.SANTINVEST_028],
  },
  {
    value: CardAccreditoEnum.SICREDI_001,
    label: CardAccreditoLabel[CardAccreditoEnum.SICREDI_001],
  },
  {
    value: CardAccreditoEnum.SICREDI_RS_002,
    label: CardAccreditoLabel[CardAccreditoEnum.SICREDI_RS_002],
  },
  {
    value: CardAccreditoEnum.SODEXHO_029,
    label: CardAccreditoLabel[CardAccreditoEnum.SODEXHO_029],
  },
  {
    value: CardAccreditoEnum.SOROCRED_030,
    label: CardAccreditoLabel[CardAccreditoEnum.SOROCRED_030],
  },
  {
    value: CardAccreditoEnum.TECBAN_031,
    label: CardAccreditoLabel[CardAccreditoEnum.TECBAN_031],
  },
  {
    value: CardAccreditoEnum.TICKET_032,
    label: CardAccreditoLabel[CardAccreditoEnum.TICKET_032],
  },
  {
    value: CardAccreditoEnum.TRICARD_034,
    label: CardAccreditoLabel[CardAccreditoEnum.TRICARD_034],
  },
  {
    value: CardAccreditoEnum.TRIVALE_033,
    label: CardAccreditoLabel[CardAccreditoEnum.TRIVALE_033],
  },
  {
    value: CardAccreditoEnum.RESERVADO_035_998,
    label: CardAccreditoLabel[CardAccreditoEnum.RESERVADO_035_998],
  },
  {
    value: CardAccreditoEnum.OUTROS_999,
    label: CardAccreditoLabel[CardAccreditoEnum.OUTROS_999],
  },
];

type Props = Omit<SelectProps, 'options'>;

const CardAccreditorSelect = forwardRef<BaseSelectRef, Props>((props, ref) => {
  return <Select {...props} options={cardAccreditorOptions} ref={ref} />;
});

export default CardAccreditorSelect;
